import { Component, inject, effect, ChangeDetectorRef, Input } from '@angular/core';
import { CommonModule, AsyncPipe } from '@angular/common';
import {
  TabBarComponent,
  TabComponent,
  TypographyComponent,
  ButtonComponent,
  DialogService,
  ButtonMenuComponent,
  DropdownMenuItemComponent
} from '@hyperkit';
import { HuntContextService } from '../../../services/hunt-context.service';
import {
  DeploymentRequirementsTabComponent,
  EmulationValidationTabComponent,
  OverviewTabComponent
} from './components';
import { CaptureDataDialogComponent } from '../../../../../modules/hunt/hunt/capture-data-dialog/capture-data-dialog.component';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
  selector: 'package-details-query-selected-view',
  standalone: true,
  imports: [
    CommonModule,
    AsyncPipe,
    TabBarComponent,
    TabComponent,
    TypographyComponent,
    ButtonComponent,
    ButtonMenuComponent,
    DropdownMenuItemComponent,
    OverviewTabComponent,
    EmulationValidationTabComponent,
    DeploymentRequirementsTabComponent,
  ],
  templateUrl: './query-selected-view.component.html',
  styleUrl: './query-selected-view.component.scss',
})
export class QuerySelectedViewComponent {
  @Input() queryInstanceKey!: string;

  private cdr = inject(ChangeDetectorRef);
  readonly hunt = inject(HuntContextService);
  readonly dialogService = inject(DialogService);

  readonly ui = this.hunt.ui;
  readonly queryLogic = this.hunt.queryLogic.selectedQuery;
  readonly isPivotQuery = this.hunt.queryLogic.isPivotQuery;

  // Signal to observable for structural directive
  readonly selectedQueryId$ = toObservable(this.ui.selectedQueryId);

  constructor() {
    // Watch relevant signals to trigger CD manually if needed
    effect(() => {
      this.ui.selectedQueryId();
      this.ui.queryViewTab();
      this.cdr.detectChanges();
    });
  }

  onPivot(): void {
    this.dialogService.open(CaptureDataDialogComponent, {
      panelClass: 'hyperkit-component',
    });
  }

  handleMenuAction(event: Event): void {
    console.log('handle menu action:', (event as any).value);
  }
}
